import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { normalize } from '../../../../../../helper/quotation';

const AmendPurPoItems = ({
    itemsArr,
    setItemsArr,
    itemData,
    originalItems,
    error,
}) => {

    const addItemRow = () => {
        const newItem = {
            item_id: "",
            item_no: "",
            unit: "",
            category: "",
            item_weight: "",
            original_qty: 0,
            quantity: 0,
            mrp: 0,
            rate: 0,
            discount: 0,
            amount: 0,
            discount_amount: 0,
            taxable_amount: 0,
            gst: 0,
            gst_amount: 0,
            total_amount: 0,
            remarks: "",
            isNew: true,
        };
        setItemsArr([...itemsArr, newItem]);
    };

    const removeItemRow = (index) => {
        const newItems = [...itemsArr];
        newItems.splice(index, 1);
        setItemsArr(newItems);
    };

    const handleItemChange = (index, name, value) => {
        let finalValue = value;
        if (["quantity", "mrp", "rate", "discount", "gst"].includes(name)) {
            if (finalValue && String(finalValue).includes('.')) {
                const parts = String(finalValue).split('.');
                if (parts[1].length > 2) {
                    finalValue = String(parseFloat(Number(finalValue).toFixed(2)));
                }
            }
        }

        setItemsArr((prev) => {
            const newItems = [...prev];
            const updatedItem = { ...newItems[index], [name]: finalValue };

            if (name === "item_id") {
                const selectedItem = itemData.find((item) => item._id === value);
                if (selectedItem) {
                    updatedItem.unit = selectedItem?.unit?.name || "";
                    updatedItem.category = selectedItem?.category?.name || "";
                    updatedItem.gst = selectedItem?.gst_percentage || 0;
                }
            }

            // Calculations
            const qty = parseFloat(updatedItem.quantity) || 0;
            const rate = parseFloat(updatedItem.rate) || 0;
            const gst = parseFloat(updatedItem.gst) || 0;
            const discount = parseFloat(updatedItem.discount) || 0;

            const amount = qty * rate;
            const discount_amount = (amount * discount) / 100;
            const taxable_amount = amount - discount_amount;
            const gst_amount = (taxable_amount * gst) / 100;
            const total_amount = taxable_amount + gst_amount;

            updatedItem.amount = Number(amount?.toFixed(2));
            updatedItem.discount_amount = Number(discount_amount?.toFixed(2));
            updatedItem.taxable_amount = Number(taxable_amount?.toFixed(2));
            updatedItem.gst_amount = Number(gst_amount?.toFixed(2));
            updatedItem.total_amount = Number(total_amount?.toFixed(2));

            newItems[index] = updatedItem;
            return newItems;
        });
    };

    const totals = React.useMemo(() => {
        return itemsArr?.reduce(
            (acc, item) => {
                acc.quantity += Number(item.quantity) || 0;
                acc.amount += Number(item.amount) || 0;
                acc.total_amount += Number(item.total_amount) || 0;
                acc.discount_amount += Number(item.discount_amount) || 0;
                acc.taxable_amount += Number(item.taxable_amount) || 0;
                acc.gst_amount += Number(item.gst_amount) || 0;
                return acc;
            },
            {
                quantity: 0,
                amount: 0,
                total_amount: 0,
                discount_amount: 0,
                taxable_amount: 0,
                gst_amount: 0,
            }
        );
    }, [itemsArr]);

    const isFieldChanged = (item, fieldName) => {
        if (!item.isExisting) return false;

        const orig = originalItems.find((o) => o._id === item._id);
        if (!orig) return false;

        return normalize(item?.[fieldName]) !== normalize(orig?.[fieldName]);
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="card bg-transparent border-0 mb-1">
                        <div className="card-header d-flex justify-content-between align-items-center py-3">
                            <h5 className="card-title mb-0 fw-bold text-primary" style={{ fontSize: "19px" }}>Items / Requirements</h5>
                            <button
                                type="button"
                                className="btn btn-primary btn-sm px-3"
                                onClick={addItemRow}
                                disabled={itemsArr.some(item => !item.item_id || !item.quantity || parseFloat(item.quantity) <= 0 || !item.rate || parseFloat(item.rate) <= 0)}
                            >
                                <i className="fa fa-plus me-1"></i> Add Item
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-4">
                <div className="col-12">
                    <div className="table-responsive bg-white">
                        <table className="table table-bordered table-nowrap table-hover mb-0 align-middle">
                            <thead className="bg-light text-center small fw-bold text-muted">
                                <tr>
                                    <th>Sr.</th>
                                    <th style={{ minWidth: "220px" }}>Item Name<span className="text-danger">*</span></th>
                                    <th>Unit</th>
                                    <th>Category</th>
                                    <th style={{ minWidth: "100px" }}>Item No</th>
                                    {/* <th>PR Qty</th> */}
                                    <th>PO Qty<span className="text-danger">*</span></th>
                                    {/* <th>Weight</th> */}
                                    <th>Orig Rate (₹)</th>
                                    <th>Pur Rate (₹)<span className="text-danger">*</span></th>
                                    <th>Amount (₹)</th>
                                    <th>Disc (%)</th>
                                    <th>Disc (₹)</th>
                                    <th>Taxable Amt (₹)</th>
                                    <th>GST (%)</th>
                                    <th>GST (₹)</th>
                                    <th>Total (₹)</th>
                                    <th style={{ minWidth: "200px" }}>Remarks</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                {itemsArr?.map((item, index) => (
                                    <>
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td className="custom-dropdown">
                                                <Dropdown
                                                    value={item.item_id}
                                                    options={itemData.map((e) => ({
                                                        label: e.name,
                                                        value: e._id,
                                                    }))}
                                                    onChange={(e) =>
                                                        handleItemChange(index, "item_id", e.value)
                                                    }
                                                    placeholder="Select Item"
                                                    filter
                                                    className="w-100"
                                                    appendTo={document.body}
                                                    disabled={item.isAuto === true}
                                                />
                                                {isFieldChanged(item, "item_id") && <small className="text-danger d-block">changed</small>}
                                                {error[index]?.item_id && <small className="text-danger d-block">{error[index].item_id}</small>}
                                            </td>
                                            <td><span className="p-2 px-3">{item.unit || "-"}</span></td>
                                            <td><span className="p-2 px-3">{item.category || "-"}</span></td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={item.item_no}
                                                    onChange={(e) =>
                                                        handleItemChange(index, "item_no", e.target.value)
                                                    }
                                                />
                                                {isFieldChanged(item, "item_no") && <small className="text-danger d-block">changed</small>}
                                            </td>
                                            {/* <td><span className="fw-bold">{item.original_qty}</span></td> */}
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm fw-semibold"
                                                    value={item.quantity}
                                                    onChange={(e) =>
                                                        handleItemChange(index, "quantity", e.target.value)
                                                    }
                                                    style={{ width: "80px", margin: "0 auto" }}
                                                />
                                                {isFieldChanged(item, "quantity") && <small className="text-danger d-block">changed</small>}
                                                {error[index]?.quantity && <small className="text-danger d-block">{error[index].quantity}</small>}
                                            </td>
                                            {/* <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm "
                                                    value={item.item_weight}
                                                    onChange={(e) =>
                                                        handleItemChange(index, "item_weight", e.target.value)
                                                    }
                                                />
                                                {isFieldChanged(item, "item_weight") && <small className="text-danger d-block">changed</small>}
                                            </td> */}
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm "
                                                    value={item.mrp}
                                                    onChange={(e) =>
                                                        handleItemChange(index, "mrp", e.target.value)
                                                    }
                                                />
                                                {isFieldChanged(item, "mrp") && <small className="text-danger d-block">changed</small>}
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm  fw-semibold text-success"
                                                    value={item.rate}
                                                    onChange={(e) =>
                                                        handleItemChange(index, "rate", e.target.value)
                                                    }
                                                    style={{ width: "100px", margin: "0 auto" }}
                                                />
                                                {isFieldChanged(item, "rate") && <small className="text-danger d-block">changed</small>}
                                                {error[index]?.rate && <small className="text-danger d-block">{error[index].rate}</small>}
                                            </td>
                                            <td><span className="fw-semibold">{Number(item.amount || 0).toFixed(2)}</span></td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm "
                                                    value={item.discount}
                                                    onChange={(e) =>
                                                        handleItemChange(index, "discount", e.target.value)
                                                    }
                                                    style={{ width: "60px", margin: "0 auto" }}
                                                />
                                                {isFieldChanged(item, "discount") && <small className="text-danger d-block">changed</small>}
                                            </td>
                                            <td><span>{Number(item.discount_amount || 0).toFixed(2)}</span></td>
                                            <td><span className="fw-semibold">{Number(item.taxable_amount || 0).toFixed(2)}</span></td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm "
                                                    value={item.gst}
                                                    onChange={(e) =>
                                                        handleItemChange(index, "gst", e.target.value)
                                                    }
                                                    style={{ width: "60px", margin: "0 auto" }}
                                                />
                                                {isFieldChanged(item, "gst") && <small className="text-danger d-block">changed</small>}
                                            </td>
                                            <td><span>{Number(item.gst_amount || 0).toFixed(2)}</span></td>
                                            <td><span className="fw-semibold">{Number(item.total_amount || 0).toFixed(2)}</span></td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={item.remarks}
                                                    onChange={(e) =>
                                                        handleItemChange(index, "remarks", e.target.value)
                                                    }
                                                    placeholder="Notes for this item"
                                                />
                                                {isFieldChanged(item, "remarks") && <small className="text-danger d-block">changed</small>}
                                            </td>
                                            <td className="text-center">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm rounded-circle"
                                                    onClick={() => removeItemRow(index)}
                                                    style={{ width: "30px", height: "30px", padding: 0 }}
                                                    disabled={item?.is_received === true}
                                                >
                                                    <i className="fa fa-trash small"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </>
                                ))}
                            </tbody>
                            <tfoot className="bg-light text-center fw-semibold">
                                <tr>
                                    <td colSpan="5" className="text-end pe-3">Total:</td>
                                    <td>{Number(totals?.quantity || 0).toFixed(2)}</td>
                                    <td></td>
                                    <td></td>
                                    <td>{Number(totals?.amount || 0).toFixed(2)}</td>
                                    <td></td>
                                    <td>{Number(totals?.discount_amount || 0).toFixed(2)}</td>
                                    <td>{Number(totals?.taxable_amount || 0).toFixed(2)}</td>
                                    <td></td>
                                    <td>{Number(totals?.gst_amount || 0).toFixed(2)}</td>
                                    <td>{Number(totals?.total_amount || 0).toFixed(2)}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AmendPurPoItems;
